import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { utils, writeFileXLSX } from "xlsx";
export default function downloadExcel(param) {
    var data = param.data, filename = param.filename, sx = param.sx;
    var download = function(data, filename) {
        if (data) {
            var ws = utils.json_to_sheet(data);
            var wb = utils.book_new();
            utils.book_append_sheet(wb, ws, filename);
            writeFileXLSX(wb, filename + ".xlsx");
        }
    };
    return /*#__PURE__*/ _jsx("button", {
        className: "btn btn-export-st-1 me-auto",
        sx: sx,
        onClick: function() {
            return download(data, filename);
        },
        children: "Export"
    });
}
export function autoFitColumns(data, ws) {
    var colWidths = [];
    var headerKeys = Object.keys(data[0] || {});
    var rows = [
        headerKeys
    ].concat(_to_consumable_array(data.map(Object.values)));
    rows.forEach(function(row) {
        row.forEach(function(val, colIndex) {
            var content = String(val || "");
            colWidths[colIndex] = Math.max(colWidths[colIndex] || 10, content.length);
        });
    });
    return colWidths.map(function(width) {
        return {
            wch: width + 2
        };
    }); // Add padding for better readability
}
;
